import apiClient from './axiosConfig';
import { getApiBaseUrl } from '../config/urls';
import { AxiosError } from 'axios';

// 定数定義
const TOKEN_KEY = 'token';
const API_BASE = getApiBaseUrl();
const DELETE_ROOM_ENDPOINT = (roomId: string) => `${API_BASE}/api/room/${roomId}`;

// 共通ロギング関数（必要に応じて使う）
const log = (message: string, ...optional: any[]) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`[deleteRoom] ${message}`, ...optional);
  }
};

// エラーメッセージの処理を共通関数化
function handleDeleteRoomError(error: unknown): never {
  if (error instanceof AxiosError && error.response) {
    const status = error.response.status;
    if (status === 404) {
      throw new Error('削除対象のルームが見つかりません');
    } else if (status === 403) {
      throw new Error('このルームを削除する権限がありません');
    } else {
      throw new Error(error.response.data?.message || 'ルーム削除中にエラーが発生しました');
    }
  }

  throw new Error((error as Error).message || '予期せぬエラーが発生しました');
}

// ルーム削除API
export const deleteRoom = async (roomId: string): Promise<void> => {
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token) {
    throw new Error('認証トークンが見つかりません。ログインしてください。');
  }

  try {
    const response = await apiClient.delete(DELETE_ROOM_ENDPOINT(roomId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { success, message } = response.data;
    if (success !== 'true') {
      throw new Error(message || 'ルーム削除に失敗しました');
    }

    log('ルーム削除成功:', roomId);
  } catch (error: unknown) {
    handleDeleteRoomError(error);
  }
};